import { rootRoute } from "@/routes";
import { Button, Spinner, VStack } from "@/shared/ui/primitives";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";

function OAuthSolapiResultPage() {
	const navigate = useNavigate();
	const status = useMemo(() => {
		const params = new URLSearchParams(window.location.search);
		return params.get("status") ?? "linked";
	}, []);

	useEffect(() => {
		if (status !== "linked") return;
		const returnUrl = sessionStorage.getItem("oauth_return_url");
		const isPopup = sessionStorage.getItem("oauth_popup_mode") === "1";
		sessionStorage.removeItem("oauth_popup_mode");
		sessionStorage.removeItem("oauth_return_url");

		if (isPopup && window.opener && !window.opener.closed) {
			window.opener.postMessage(
				{
					type: "inflect:solapi-oauth-complete",
					status,
					returnUrl: returnUrl?.startsWith("/") ? returnUrl : null,
				},
				window.location.origin,
			);
			window.close();
			return;
		}
		if (returnUrl?.startsWith("/")) {
			window.location.assign(returnUrl);
			return;
		}
		navigate({ to: "/" });
	}, [navigate, status]);

	const message =
		status === "linked"
			? "Solapi 연동이 완료되었습니다. 원래 화면으로 돌아가는 중입니다."
			: status === "missing"
				? "Solapi 연동 정보가 부족합니다. 다시 시도해 주세요."
				: "Solapi 연동 중 오류가 발생했습니다. 다시 시도해 주세요.";

	return (
		<VStack className="min-h-screen items-center justify-center gap-4 p-4">
			{status === "linked" ? <Spinner size="md" /> : null}
			<span className="text-ct-strong font-medium text-center">{message}</span>
			<Button
				variant="primary"
				onClick={() => {
					const returnUrl = sessionStorage.getItem("oauth_return_url");
					sessionStorage.removeItem("oauth_popup_mode");
					sessionStorage.removeItem("oauth_return_url");
					if (returnUrl?.startsWith("/")) {
						window.location.assign(returnUrl);
						return;
					}
					navigate({ to: "/" });
				}}
			>
				돌아가기
			</Button>
		</VStack>
	);
}

export const oauthSolapiResultRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/oauth/solapi/result",
	component: OAuthSolapiResultPage,
});
